<template>
  <!--   <rt-section id="area9" :title="$t('annotation')"> -->
  <div class="annotation">
    <template slot="toolbar">
      <input
        type="file"
        value="请点击上传附件"
        @change="onFileChange"
        style="display: none"
        ref="upload"
      />
      <rt-button
        :text="$t('BUTTON_UPLOAD')"
        type="add"
        @click="uploadFile"
        :disabled="disabledStatus"
        v-show="showAdd"
      />
      <rt-button
        type="delete"
        @click="deleteData"
        :disabled="disabledStatus"
        v-show="showDelete"
      />
    </template>
    <div class="annotationTop">
      <span>注释</span>
      <el-button
        @click="uploadFile"
        :disabled="disabledStatus"
        v-show="showAdd"
        >{{ $t("BUTTON_UPLOAD") }}</el-button
      >
      <el-button
        @click="deleteData"
        :disabled="disabledStatus"
        v-show="showDelete"
        >删除</el-button
      >
    </div>
    <el-table ref="gridTable" :data="attachmentData" v-loading="loading">
      <el-table-column type="selection" width="35"> </el-table-column>
      <el-table-column
        :label="$t('annotation.filename')"
        prop="filename"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column :label="$t('annotation.filesize')" prop="filesize">
      </el-table-column>
      <el-table-column
        :label="$t('annotation.subject')"
        prop="subject"
        v-if="showDetail"
      >
      </el-table-column>
      <el-table-column
        :label="$t('annotation.nodetext')"
        prop="nodetext"
        v-if="showDetail"
      >
      </el-table-column>
      <el-table-column :label="$t('annotation.createdon')" prop="createdon">
      </el-table-column>
      <el-table-column label="预览" width="150">
        <template slot-scope="scope">
          <a
            v-show="isNotIE"
            :href="scope.row.filelink"
            target="_blank"
            @click="downLoadFile(scope.$index, scope.row)"
            >点击预览</a
          >
          <a
            v-show="isIE"
            href="#"
            @click="downLoadOrOpenFile(scope.$index, scope.row)"
            >点击预览</a
          >
        </template>
      </el-table-column>
      <el-table-column :label="$t('ACT')" width="81">
        <template slot-scope="scope">
          <a
            :href="scope.row.filelink"
            :download="scope.row.filename"
            @click="downLoadFile(scope.$index, scope.row)"
            >下载</a
          >
        </template>
      </el-table-column>
    </el-table>
  </div>
  <!--   </rt-section> -->
</template>

<script>
export default {
  name: "RtAnnotation",
  data: function () {
    return {
      loading: false,
      dialogVisible: false,
      attachmentData: [],
      fileAutoSize: 10485760, //10M大小文件限制
      isIE: false,
      isNotIE: true,
    };
  },

  props: {
    entityname: {
      type: String,
      require: true,
    },
    objectid: {
      type: String,
      require: true,
    },
    showDetail: {
      type: Boolean,
      require: true,
    },
    disabledStatus: {
      type: Boolean,
      require: false,
    },
    showAdd: {
      type: Boolean,
      require: false,
    },
    showDelete: {
      type: Boolean,
      require: false,
    },
    subject: {
      type: String,
      require: false,
    },
    noteText: {
      type: String,
      require: true,
    },
    stateFied: {},
    stateValue: {
      type: Number,
    },
  },
  mounted: function () {
    this.attachmentData = [];
    this.$nextTick(() => this.fetchRecords());
    let userAgent = navigator.userAgent;
    if (userAgent.indexOf("Trident") > -1) {
      //用于IE浏览器
      this.isIE = true;
      this.isNotIE = false;
    } else {
      this.isIE = false;
      this.isNotIE = true;
    }
  },
  methods: {
    //加载附件明细
    fetchRecords: function () {
      if (this.objectid) {
        this.loading = true;
        var requestStr = "../api/annotation/getannotation/" + this.objectid;
        rt.get(requestStr)
          .then((res) => {
            var attachmentList = res;
            var list = this.mapAttachments(attachmentList);
            this.attachmentData = list;
            this.loading = false;
            this.$emit("isExitatt", this.attachmentData.length);
          })
          .catch((error) => {
            rt.showErrorToast(error);
            this.loading = false;
          });
      }
    },

    mapAttachments: function (attachmentList) {
      var list = [];
      attachmentList.map((step) => {
        let filelink = "data:" + step.mimetype + ";base64," + step.documentbody;
        let blob = this.base64Img2Blob(filelink);
        let userAgent = navigator.userAgent;
        step.filelink = window.URL.createObjectURL(blob);
        step.blob = blob;
        list.push(step);
      });
      return list;
    },

    //input输入框发生变化时触发该事件
    onFileChange: function () {
      var that = this;
      var id = that.objectid;
      var files = that.$refs.upload.files;
      var reader = new FileReader();
      var file = files[0];
      var ifSame = that.checkSameName(file.name);
      if (ifSame) {
        that.$message({
          type: "warning",
          message: that.$t("ExistSameFile"),
        });
      } else {
        reader.readAsDataURL(file);
        reader.onload = function (f) {
          //debugger;
          //大小限制
          if (file.size >= that.fileAutoSize) {
            that.$message({
              type: "warning",
              message: that.$t("FileIn10M"),
            });
          } else {
            //debugger;
            var annotation = {};
            annotation["filename"] = file.name;
            annotation["type"] = file.type;
            if (f.target.result !== "data:") {
              annotation["documentbody"] = f.target.result.substring(
                f.target.result.indexOf(",") + 1
              );
            }
            if (that.showDetail) {
              annotation["subject"] = that.subject;
              annotation["notetext"] = that.noteText;
            }
            annotation["id"] = id;
            annotation["filesize"] = file.size;
            annotation["entityname"] = that.entityname;
            var requestStr = "../api/annotation/addannotation";
            rt.post(requestStr, annotation)
              .then((res) => {
                rt.showSuccessToast(res);
                that.fetchRecords();
              })
              .catch((error) => {
                rt.showErrorToast(error);
              });
          }
        };
      }
      that.$refs.upload.value = "";
    },
    //检查是否有同名文件
    checkSameName: function (val) {
      if (this.attachmentData.length == 0) {
        return false;
      } else {
        for (var i in this.attachmentData) {
          if (this.attachmentData[i].filename == val) {
            return true;
          }
        }
        return false;
      }
    },
    //上传附件
    uploadFile: function () {
      if (rt.isNullOrWhiteSpace(this.objectid)) {
        this.$message({
          type: "warning",
          message: this.$t("PleaseSave"),
        });
        return;
      }
      //审核中或者已审核状态下不可以添加明细
      if (this.approvalstatus) {
        if (
          (this.approvalstatus != 1 && this.approvalstatus != 4) ||
          this.approvalstatus == 5
        ) {
          this.$message({
            type: "warning",
            message: this.$t("NotSingleAndRejectCanNotAdd"),
          });
          return;
        }
      }
      this.$refs.upload.click();
    },
    //删除附件
    deleteData: function () {
      //暂时不做删除限制
      // if (
      //   (this.approvalstatus != 1 && this.approvalstatus != 4) ||
      //   this.approvalstatus == 5
      // ) {
      //   this.$message({
      //     type: "warning",
      //     message: this.$t("NotSingleAndRejectCanNotDel")
      //   });
      //   return;
      // }
      var selection = this.$refs.gridTable.selection;
      if (selection == null || selection.length == 0) {
        this.$message({
          type: "warning",
          message: this.$t("PleaseChooseAtLeastOne"),
        });
      } else {
        this.$confirm(this.$t("ThisActionDeletePerpetually"), this.$t("Tip"), {
          confirmButtonText: this.$t("BUTTON_DETERMINE"),
          confirmButtonClass: "ConfirmButtonClass",
          cancelButtonText: this.$t("BUTTON_CANCEL"),
          cancelButtonClass: "CancelButtonClass",
          type: "warning",
        })
          .then(() => {
            this.loading = true;
            var deleteList = [];
            for (var i in selection) {
              //debugger;
              deleteList.push(selection[i].annotationid);
            }
            var params = deleteList;
            var requestStr = "../api/annotation/deleteannotation";
            rt.post(requestStr, params)
              .then((res) => {
                rt.showSuccessToast(res);
                this.fetchRecords();
              })
              .catch((error) => {
                rt.showErrorToast(error);
                this.loading = false;
              });
          })
          .catch((error) => {
            this.$message({
              type: "info",
              message: this.$t("HasCancelledForDeleting"),
            });
          });
      }
    },
    //下载附件
    downLoadFile: function (index, row) {
      let filelink = "data:" + row.mimetype + ";base64," + row.documentbody;
      row.blob = this.base64Img2Blob(filelink);
      row.filelink = window.URL.createObjectURL(row.blob);
      let userAgent = navigator.userAgent;
      if (userAgent.indexOf("Trident") > -1) {
        //用于IE浏览器
        //window.navigator.msSaveBlob(row.blob, row.filename);
        window.navigator.msSaveBlob(row.blob, row.filename);
      }
    },
    //针对IE浏览器下  区分预览和下载两种情况
    downLoadOrOpenFile: function (index, row) {
      let filelink = "data:" + row.mimetype + ";base64," + row.documentbody;
      row.blob = this.base64Img2Blob(filelink);
      let userAgent = navigator.userAgent;
      if (userAgent.indexOf("Trident") > -1) {
        window.navigator.msSaveOrOpenBlob(row.blob, row.filename);
      }
    },
    base64Img2Blob: function (code) {
      var parts = code.split(";base64,");
      var contentType = parts[0].split(":")[1];
      var raw = window.atob(parts[1]);
      var rawLength = raw.length;

      var uInt8Array = new Uint8Array(rawLength);

      for (var i = 0; i < rawLength; ++i) {
        uInt8Array[i] = raw.charCodeAt(i);
      }
      return new Blob([uInt8Array], {
        type: contentType,
      });
    },
  },
};
</script>
<style scoped>
.annotationTop {
  height: 30px;
  margin:20px 0 10px 0;
}
.annotationTop span {
  font-size: 16px;
  color: #00a0d9;
  line-height: 30px;
}
.annotationTop .el-button {
  height: 30px;
  color: #00a0d9;
  border-color: #00a0d9;
  float: right;
  margin-left: 10px;
}
</style>
<style>
.annotation .el-table__header-wrapper thead th,
.annotation .el-table__header-wrapper thead th .cell {
  background-color: #f5f5f5;
}
.annotation .el-table__header-wrapper thead th {
  border-top: 1px solid #ebebeb!important;
}
</style>



// WEBPACK FOOTER //
// main.vue?1f7e83b8